import Model from '../Model';
import computed from '../utils/computed';
import { getPlainContent } from '../utils/string';
import Discussion from './Discussion';
import User from './User';

export default class Post extends Model {
  number() {
    return Model.attribute<number>('number').call(this);
  }
  activityId() {
    return Model.attribute<number>('activityId').call(this);
  }
  activityTagId() {
    return Model.attribute<number>('activityTagId').call(this);
  }
  isJoin() {
    return Model.attribute<number>('isJoin').call(this);
  }
  activityIsHand() {
    return Model.attribute<boolean>('activityIsHand').call(this);
  }
  discussion() {
    return Model.hasOne<Discussion>('discussion').call(this) as Discussion;
  }

  createdAt() {
    return Model.attribute<Date, string>('createdAt', Model.transformDate).call(this);
  }
  top() {
    return Model.attribute<number | undefined>('top').call(this);
  }
  latest() {
    return Model.attribute<number | undefined>('latest').call(this);
  }
  user() {
    return Model.hasOne<User>('user').call(this);
  }

  contentType() {
    return Model.attribute<string | null>('contentType').call(this);
  }
  content() {
    return Model.attribute<string | null | undefined>('content').call(this);
  }
  contentHtml() {
    return Model.attribute<string | null | undefined>('contentHtml').call(this);
  }
  renderFailed() {
    return Model.attribute<boolean | undefined>('renderFailed').call(this);
  }
  contentPlain() {
    return computed<string | null | undefined>('contentHtml', (content) => {
      if (typeof content === 'string') {
        return getPlainContent(content);
      }

      return content as null | undefined;
    }).call(this);
  }

  editedAt() {
    return Model.attribute('editedAt', Model.transformDate).call(this);
  }
  editedUser() {
    return Model.hasOne<User | null>('editedUser').call(this);
  }
  replyToUser() {
    return Model.hasOne<Post | null>('replyToUser').call(this);
  }
  replyToPost() {
    return Model.hasOne<Post | null>('replyToPost').call(this);
  }
  isEdited() {
    return computed<boolean>('editedAt', (editedAt) => !!editedAt).call(this);
  }

  hiddenAt() {
    return Model.attribute('hiddenAt', Model.transformDate).call(this);
  }
  hiddenUser() {
    return Model.hasOne<User | null>('hiddenUser').call(this);
  }
  isHidden() {
    return computed<boolean>('hiddenAt', (hiddenAt) => !!hiddenAt).call(this);
  }

  canEdit() {
    return Model.attribute<boolean | undefined>('canEdit').call(this);
  }
  canHide() {
    return Model.attribute<boolean | undefined>('canHide').call(this);
  }
  canDelete() {
    return Model.attribute<boolean | undefined>('canDelete').call(this);
  }
  likesCount() {
    return Model.attribute<number>('likesCount').call(this);
  }

}
